
class navbarModule
{
    static scroll() {

        const navbarTogglable = document.querySelectorAll('.navbar-togglable');
        const windowEvents = ['load', 'scroll'];

        function navbarOnTop(navbar) {
            navbar.classList.remove('navbar-light');
            navbar.classList.add('navbar-dark');
            navbar.classList.remove('shadow');
            navbar.classList.remove('bg-white');
            navbar.classList.remove('navbar-offset')
            //navbar.style.top = '2rem';
        }

        function navbarScrolling(navbar) {
            navbar.classList.remove('navbar-dark');
            navbar.classList.add('navbar-light');
            navbar.classList.add('bg-white');
            navbar.classList.add('shadow');
            navbar.classList.add('navbar-offset')
        }

        function toggleNavbar(navbar) {
            const scrollTop = window.pageYOffset;

            if (scrollTop) {
                navbarScrolling(navbar);
            }

            if (!scrollTop) {
                navbarOnTop(navbar);
            }
        }

        navbarTogglable.forEach(function(navbar) {
            windowEvents.forEach(function(event) {
                window.addEventListener(event, function() {
                    toggleNavbar(navbar);
                });
            });
        });

    }

    static collapse() {

        const navbarCollapse = document.querySelectorAll('.navbar-collapse');

        function overflowHide() {
            const scrollbarWidth = getScrollbarWidth();

            document.documentElement.style.overflow = 'hidden';
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }

        function overflowShow() {
            document.documentElement.style.overflow = '';
            document.body.style.paddingRight = '';
        }

        function getScrollbarWidth() {
            return window.innerWidth - document.documentElement.clientWidth;
        }

        navbarCollapse.forEach(function(collapse) {
            collapse.addEventListener('show.bs.collapse', function() {
                overflowHide();
            });

            collapse.addEventListener('hidden.bs.collapse', function() {
                overflowShow();
            });
        });

    }

    static dropdown() {

        /** Selectors */
        const drops = document.querySelectorAll('.navbar-nav .dropdown, .navbar-nav .dropend');

        /** Events */
        const showEvents = ['mouseenter'];
        const hideEvents = ['mouseleave', 'click'];

        /** Transition */
        const transitionDuration = 200;

        /** Breakpoint */
        const desktopSize = 992;

        /** Show drop */
        function showDrop(menu) {
            if (window.innerWidth < desktopSize) {
                return;
            }

            menu.classList.add('showing');

            setTimeout(function() {
                menu.classList.remove('showing');
                menu.classList.add('show');
            }, 1);
        }

        /** Hide drop */
        function hideDrop(e, menu) {
            setTimeout(function() {
                if (window.innerWidth < desktopSize) {
                    return;
                }

                if (!menu.classList.contains('show')) {
                    return;
                }

                if (e.type === 'click' && e.target.closest('.dropdown-menu form')) {
                    return;
                }

                menu.classList.add('showing');
                menu.classList.remove('show');

                setTimeout(function() {
                    menu.classList.remove('showing');
                }, transitionDuration);
            }, 2);
        }

        drops.forEach(function(dropdown) {
            const menu = dropdown.querySelector('.dropdown-menu');

            // Show drop
            showEvents.forEach(function(event) {
                dropdown.addEventListener(event, function() {
                    showDrop(menu);
                });
            });

            // Hide drop
            hideEvents.forEach(function(event) {
                dropdown.addEventListener(event, function(e) {
                    hideDrop(e, menu);
                });
            });
        });

    }

    static run() {

        this.scroll();
        this.collapse();
        this.dropdown();

    }
}

export default navbarModule;
